// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5405":"21489d65","6452":"81e727c3","6850":"e8ef20e7","6942":"4071c1ca"}[chunkId] + ".chunk.css";
};